import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const EmployeeAttendanceCalendar = Loadable(lazy(() => import('./EmployeeAttendanceCalendar')));

const employeeAttendanceRoutes = [
    { path: '/employee/attendance', element: <EmployeeAttendanceCalendar />, auth: authRoles.guest },
];

export default employeeAttendanceRoutes;
